import { startSubmit, stopSubmit, getFormValues } from 'redux-form'
import { UnauthorizedError, ForbiddenError } from 'api'
import { createClient, loadAuthToken, loadCurrentUser } from 'auth'
import { handleError } from 'errors'
import { apiUrl } from 'config'

import { FORM_NAME } from './constants'
import qs from 'qs'

export const login = () => (dispatch, getState) => {
  const state = getState()
  const { email, password } = getFormValues(FORM_NAME)(state)
  dispatch(startSubmit(FORM_NAME))
  return createClient(state)
    .post('/auth/login', {
      body: {
        email,
        password
      }
    })
    .then((response) => response.json())
    .then((body) => {
      const queryParams = qs.parse(window.location.search?.split('?')?.[1])
      if (queryParams?.redirect_uri && queryParams?.response_type && queryParams?.state) {
        const redirectUrl = `${apiUrl}/v2/sso/authorize?${qs.stringify({
          redirect_uri: queryParams.redirect_uri,
          response_type: queryParams.response_type,
          state: queryParams.state
        })}`
        window.location.href = redirectUrl
        return
      }

      dispatch(loadAuthToken(body.token))
      return createClient(getState()).get('/v2/users/current')
        .then((response) => response.json())
        .then((user) => {
          dispatch(loadCurrentUser(user))
          dispatch(stopSubmit(FORM_NAME))
        })
    })
    .catch((err) => {
      if (err instanceof UnauthorizedError) {
        dispatch(stopSubmit(FORM_NAME, {
          _error: 'Your username or password is incorrect'
        }))
      } else if (err instanceof ForbiddenError) {
        dispatch(stopSubmit(FORM_NAME, {
          _error: 'require_confirmation'
        }))
      } else {
        dispatch(stopSubmit(FORM_NAME))
        dispatch(handleError(err))
      }
      return err
    })
}
